"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PlusIcon = function PlusIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9989 3.99927C10.9989 3.44698 10.5511 2.9993 9.99886 2.99935C9.44658 2.99939 8.9989 3.44715 8.99894 3.99943L8.99935 8.99955L4.00114 8.99915C3.44885 8.9991 3.0011 9.44678 3.00106 9.99906C3.00101 10.5513 3.44869 10.9991 4.00098 10.9991L8.99951 10.9996L8.99992 16.0001C8.99996 16.5524 9.44772 17.0001 10 17.0001C10.5523 17 11 16.5523 10.9999 16L10.9995 10.9997L15.9999 11.0001C16.5522 11.0002 16.9999 10.5525 17 10.0002C17 9.44792 16.5523 9.00017 16 9.00012L10.9994 8.99971L10.9989 3.99927Z",
    fill: color
  }));
};

var _default = PlusIcon;
exports.default = _default;